<template>
  <div class="mention-dropdown">
    <div v-if="items.length === 0" class="empty">Type to search...</div>

    <button
      v-for="(item, index) in items"
      :key="item.id"
      :class="{ selected: index === selectedIndex }"
      @click="selectItem(index)"
      type="button"
    >
      {{ item.title || item.label || item.name }}
    </button>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  items: { type: Array, required: true },
  command: { type: Function, required: true }
})

const selectedIndex = ref(0)

watch(
  () => props.items,
  () => { selectedIndex.value = 0 },
  { immediate: true }
)

function onKeyDown({ event }) {
  if (event.key === 'ArrowUp') {
    upHandler()
    return true
  }
  if (event.key === 'ArrowDown') {
    downHandler()
    return true
  }
  if (event.key === 'Enter') {
    enterHandler()
    return true
  }
  return false
}

function upHandler() {
  selectedIndex.value =
    (selectedIndex.value + props.items.length - 1) % props.items.length
}

function downHandler() {
  selectedIndex.value =
    (selectedIndex.value + 1) % props.items.length
}

function enterHandler() {
  selectItem(selectedIndex.value)
}

function selectItem(index) {
  const item = props.items[index]
  if (item) props.command({ id: item.id, label: item.title || item.label || item.name })
}

defineExpose({ onKeyDown })
</script>

<style scoped>
.mention-dropdown {
  display: flex;
  flex-direction: column;
  background: white;
  color: #111;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  padding: 4px;
  max-height: 260px;
  overflow-y: auto;
  z-index: 9999;
  min-width: 220px;
}

.mention-dropdown .empty {
  padding: 8px 12px;
  color: #888;
  font-size: 14px;
}

.mention-dropdown button {
  text-align: left;
  padding: 8px 12px;
  border: none;
  background: transparent;
  font-size: 14px;
  cursor: pointer;
  border-radius: 4px;
  color: #111;
}

.mention-dropdown button:hover {
  background: #f5f5f5;
}

.mention-dropdown button.selected {
  background: #e3f2fd;
  color: #0b63c7;
  font-weight: 500;
}
</style>